<template>
  <v-app>
    <v-main class="screen">
      <error-modal />
      <router-view
        class="view layout authenticated"
        name="AuthenticatedLayout"
      />
      <router-view class="view layout" name="UnauthenticatedLayout" />
      <div class="overlay-wrapper" v-if="getSidebarIsOpen && loggedInUser">
        <v-overlay v-model="getSidebarIsOpen" contained class="dark-overlay" />
      </div>
      <router-view
        class="view main-content"
        :class="[
          loggedInUser ? 'is-logged-in' : '',
          getSidebarIsOpen ? 'sidebar-open' : '',
        ]"
      />
    </v-main>
  </v-app>
</template>

<script>
import "@/assets/css/main.scss";
import "@/assets/css/responsive.scss";
import { mapGetters } from "vuex";

import ErrorModal from "@/components/global/modalComponents/errorModal/ErrorModal";

export default {
  name: "App",
  components: {
    ErrorModal,
  },
  data() {},
  created() {},
  computed: {
    ...mapGetters({
      loggedInUser: "users/loggedInUser",
      getSidebarIsOpen: "siteSettings/sidebarIsOpen",
    }),
  },
};
</script>

<style lang="scss">
.screen {
  background-color: #f7f7f7;
  .view {
    &.main-content {
      overflow-y: auto;
      height: calc(100% - 60px);
      transition: all 0.4s;
      &.is-logged-in {
        width: 100%;
        padding-right: 14px;
        padding-left: 14px;
        position: fixed;
        right: 0;
        padding-bottom: 20px;
        &.sidebar-open {
          padding-left: 240px;
        }
      }
    }
  }
  .overlay-wrapper {
    display: none;
  }
}

.table-no-data {
  margin-top: -25px;
  h3 {
    color: #b2b0b0;
    font-size: 25px;
    font-weight: 700;
  }
  p {
    color: #a8a8a8;
  }
}

.loading {
  padding: 32px 0;
  text-align: center;
}

.v-table {
  .v-table__wrapper {
    td {
      font-weight: 400;
      font-size: 14px;
      color: #000000de;
    }
    thead {
      tr {
        th {
          span {
            font-weight: 600;
            font-size: 14px;
            color: #000000de;
          }
        }
      }
    }
  }
}

.v-data-table__td {
  .v-data-table-header__content {
    font-weight: 600;
    font-size: 14px;
    color: #000000de;
  }
}
.v-data-table__tr {
  font-weight: 400;
  font-size: 14px;
  color: #000000de;
}
</style>
